import request from '@/router/axios'

export function fetchSpaceshipList() {
  return request({
    url: '/module/mcdonalds/admin/manager-contest/spaceships',
    method: 'get',
  })
}

export function fetchSpaceshipBoostRecordList(param) {
  return request({
    url: '/module/mcdonalds/admin/manager-contest/spaceship/record',
    method: 'get',
    params: param
  })
}

export function exportSpaceshipBoostRecord(data) {
  return request({
    url: '/module/mcdonalds/admin/manager-contest/spaceship/record/export',
    method: 'post',
    data
  })
}


export function fetchStoreContestRecord(params) {
  return request({
    url: '/module/mcdonalds/admin/manager-contest/store-contest/record',
    method: 'get',
    params
  })
}

export function exportStoreContestRecord(data) {
  return request({
    url: '/module/mcdonalds/admin/manager-contest/store-contest/record/export',
    method: 'post',
    data
  })
}


// 获取赛事统计_餐厅比拼列表
export function fetchStoreContestStatistics(params) {
  return request({
    url: '/module/mcdonalds/admin/manager-contest/store-contest/stats',
    method: 'get',
    params
  })
}

export function exportStoreContestStatistics(data) {
  return request({
    url: '/module/mcdonalds/admin/manager-contest/store-contest/stats/export',
    method: 'post',
    data
  })
}

// pk

export function fetchOnlinePkRecordData(params) {
  return request({
    url: '/module/mcdonalds/admin/manager-contest/online-pk-result',
    method: 'get',
    params
  })
}

export function exportOnlinePkRecordData(data) {
  return request({
    url: '/module/mcdonalds/admin/manager-contest/online-pk-result/export',
    method: 'post',
    data
  })
}

export function fetchOnlinePkStatisticsData(params) {
  return request({
    url: '/module/mcdonalds/admin/manager-contest/online-pk-result-stats',
    method: 'get',
    params
  })
}

export function exportOnlinePkStatisticsData(data) {
  return request({
    url: '/module/mcdonalds/admin/manager-contest/online-pk-result-stats/export',
    method: 'post',
    data
  })
}


